// const degToRadConversionConst = Math.PI/180
// const degToRad = (deg) => deg*degToRadConversionConst;

export class SVG{
  /**
   * Initialises an new SVG Object.
   * @param {string} path_to_svg The SVG file path.
   */
  constructor(path_to_svg){
    this.file_path = path_to_svg 
  }

  /**
   * Fetches the SVG object from the server and parses the data.
   */
  async load(){
    const data = await (await fetch(this.file_path)).text()
    const svgParser = new DOMParser();
    const svg = svgParser.parseFromString(data, "text/html");
    [this.orignalX, this.orignalY, this.orignalWidth, this.originalHeight] = svg.getElementsByTagName("svg")[0].getAttribute("viewBox").split(" ").map(n => Number(n));
    this.paths = Array.from(svg.getElementsByTagName("path")).map(d => d.getAttribute('d'));
  }

  /**
   * Renders the SVG image on a given canvas context.
   * @param {CanvasRenderingContext2D} canvasCtx The canvas rendering context.
   * @param {number} x The center x coordinate of the SVG image. TAKE NOTE I SAID CENTER!!!
   * @param {number} y The center y coordinate of the SVG image. TAKE NOTE I SAID CENTER!!!
   * @param {number} width The width of the SVG Image.
   * @param {number} height The height of the SVG Image.
   * @param {string} colour The icon fill colour.
   * @param {number} rotation The rotation of the SVG Image.
   */
  render(canvasCtx, x, y, width, height, colour, rotation){
    if (this.paths && this.paths.length > 0){
      canvasCtx.fillStyle = colour;
      // References: 
      // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/translate
      // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/scale
      const baseOffsetX = this.orignalX*-1*(width/this.orignalWidth) + x;
      const baseOffsetY = this.orignalY*-1*(height/this.originalHeight) + y;
      // canvasCtx.translate(baseOffsetX, baseOffsetY);
      // const rotationRad = degToRad(rotation || 90);
      // const rotationOffset = rotationRad + Math.PI*1.25;
      // canvasCtx.rotate(rotationRad)
      // canvasCtx.translate(width/-2,height/-2);
      // const rotationRadius = Math.sqrt((width/2)**2 + (height/2)**2);
      // canvasCtx.translate((height/2)*Math.cos(rotationOffset), (width/2)*Math.sin(rotationOffset));
      canvasCtx.translate(baseOffsetX - width/2,baseOffsetY - height/2);
      canvasCtx.scale(width/this.orignalWidth, height/this.originalHeight);
      for (let i=0; i < this.paths.length; i++){
        canvasCtx.fill(new Path2D(this.paths[i]));
      }
      canvasCtx.setTransform(1, 0, 0, 1, 0, 0);
    }
  }
}


/*
const parser = new DOMParser();
const htmlString = `<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#e3e3e3"><path d="M220-240v-480h60v480h-60Zm520 0L394-480l346-240v480Z"/></svg>`;
const doc = parser.parseFromString(htmlString, "text/html");
const canvas = document.getElementById("canvas");
const ctx = canvas.getContext("2d");
const paths = doc.getElementsByTagName("path")
const [orignalX, orignalY, orignalWidth, originalHeight] = doc.getElementsByTagName("svg")[0].getAttribute("viewBox").split(" ").map(n => Number(n));
const [x, y, width, height] = [0,0,100,100];
console.log([orignalX, orignalY, orignalWidth, originalHeight])

ctx.translate(orignalX*-1*(width/orignalWidth) + x,orignalY*-1*(height/originalHeight) + y);
ctx.scale(width/orignalWidth, height/originalHeight)
for (let i=0; i < paths.length; i++){
  const p = new Path2D(paths[i].getAttribute("d"));
  ctx.fill(p);
}
ctx.setTransform(1, 0, 0, 1, 0, 0);
ctx.beginPath();
ctx.rect(x, y, width, height)
ctx.stroke();
*/

export class PNG{
  /**
   * Initialises an new PNG Object.
   * @param {string} path_to_png The PNG file path.
   */
  constructor(path_to_png){
    this.file_path = path_to_png
  }

  /**
   * Fetches the PNG object from the server and parses the data.
   */
  async load(){
    const img = new Image();
    img.src = this.file_path;
    await img.decode();
    this.img = img;
    this.width = img.width;
    this.height = img.height;
  }

  /**
   * Renders the PNG image on a given canvas context.
   * @param {CanvasRenderingContext2D} canvasCtx The canvas rendering context.
   * @param {number} x The x coordinate of the SVG image.
   * @param {number} y The y coordinate of the SVG image.
   * @param {number} width The width of the SVG Image.
   * @param {number} height The height of the SVG Image.
   */
  render(canvasCtx, x, y, width, height){
    canvasCtx.drawImage(this.img, x, y, width, height);
  }
}